import { render, staticRenderFns } from "./quarter-review.vue?vue&type=template&id=12ae1a62&scoped=true"
import script from "./quarter-review.vue?vue&type=script&lang=js"
export * from "./quarter-review.vue?vue&type=script&lang=js"
import style0 from "./quarter-review.vue?vue&type=style&index=0&id=12ae1a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ae1a62",
  null
  
)

export default component.exports